var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "tenantTnc__main-container" }, [
    _c("div", { staticClass: "tenantTnc__text-container" }, [
      _c("div", { staticClass: "mainTitle_container" }, [
        _c("p", [_vm._v(_vm._s(_vm.title))])
      ]),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "text_container", attrs: { id: "tenantTncText" } },
        [
          _c("div", {
            staticClass: "subText__container",
            class: _vm.isEndUser ? "" : "addWidth",
            domProps: { innerHTML: _vm._s(_vm.templateData) }
          })
        ]
      ),
      _vm._v(" "),
      _vm.isEndUser
        ? _c(
            "div",
            { staticClass: "main_footer_container" },
            [
              _c("v-checkbox", {
                attrs: {
                  color: "#638AFF",
                  label: "I agree to the terms of the Constella " + _vm.title
                },
                model: {
                  value: _vm.agreeTncCheckBox,
                  callback: function($$v) {
                    _vm.agreeTncCheckBox = $$v
                  },
                  expression: "agreeTncCheckBox"
                }
              }),
              _vm._v(" "),
              _c("div", { staticClass: "sub_footer_container" }, [
                _c(
                  "p",
                  {
                    staticClass: "download",
                    on: {
                      click: function($event) {
                        return _vm.downloadFile()
                      }
                    }
                  },
                  [
                    _c("v-icon", { staticClass: "mr-1" }, [
                      _vm._v("icon-download_file")
                    ]),
                    _vm._v("Download")
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "actionButtons" },
                  [
                    _c(
                      "v-btn",
                      {
                        staticClass: "cancel",
                        on: {
                          click: function($event) {
                            return _vm.cancelTnc()
                          }
                        }
                      },
                      [_vm._v("Cancel")]
                    ),
                    _vm._v(" "),
                    _c(
                      "v-btn",
                      {
                        staticClass: "agree",
                        class: _vm.agreeTncCheckBox ? "enable" : "disable",
                        on: {
                          click: function($event) {
                            return _vm.agreeTnc()
                          }
                        }
                      },
                      [_vm._v("I AGREE")]
                    )
                  ],
                  1
                )
              ])
            ],
            1
          )
        : _c(
            "div",
            { staticClass: "main_footer_container buttons mt-5" },
            [
              _c(
                "v-btn",
                {
                  staticClass: "commonButton",
                  on: {
                    click: function($event) {
                      return _vm.backToLogin()
                    }
                  }
                },
                [_vm._v("Back to Login")]
              )
            ],
            1
          )
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }